<template>
  <component
    :is="computedTag"
    :href="href"
    :class="getComputedClasses"
    class="button"
    @click="onClick"
  >
    <div class="loader-wrapper">
      <div class="loader" v-if="loading" />
    </div>
    <slot />
  </component>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: null
    },
    to: {
      type: String,
      default: null
    },
    /* display: block */
    block: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'main',
      validator: val => ['main', 'light', 'simple'].includes(val)
    }
  },
  computed: {
    getComputedClasses () {
      return {
        button_disabled: this.disabled,
        button_block: this.block,
        button_loading: this.loading,
        ['button_' + this.theme]: true
      }
    },
    computedTag () {
      if (this.href) {
        return 'a'
      }
      return 'button'
    }
  },
  emits: {
    click: null
  },
  methods: {
    onClick () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  position: relative;
  height: 42px;
  padding: 0 64px;
  border-radius: 12px;
  border: none;
  font: inherit;
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  transition: .2s;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  &_loading {
    color: transparent !important;
    transition: none !important;
  }

  &_main {
    background: linear-gradient(180deg, #FA7E0D 0%, #D25C15 100%);
    color: #FFFFFF;

    &:hover {
      background: linear-gradient(180deg, #FA7E0D 0%, #FE9E47 0.01%, #F4762B 100%);
    }
  }

  &_light {
    background: #E5E5E6;
    color: #000;
  }

  &_simple {
    background: transparent;
    color: #fff;
  }

  &_block {
    width: 100%;
    display: block;
  }

  &_disabled {
    pointer-events: none;
    background: #282828;
    color: #4A4A4A;
  }

  /* LOADER */
  .loader-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .loader {
    $size: 30px;
    $borderRadius: 50%;
    $sizeMin: $size / 7;

    position: relative;
    border-radius: $borderRadius;
    width: $size;
    height: $size;
    border-top: $sizeMin solid rgba(255, 255, 255, 0.2);
    border-right: $sizeMin solid rgba(255, 255, 255, 0.2);
    border-bottom: $sizeMin solid rgba(255, 255, 255, 0.2);
    border-left: $sizeMin solid #ffffff;
    transform: translateZ(0);
    animation: load8 1.1s infinite linear;

    &:after {
      border-radius: $borderRadius;
      width: $size;
      height: $size;
    }

    @keyframes load8 {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}
</style>
